export default {
  namespaced: true,
  state: {
    isMeetingModalVisible: false,
    isPhoneModalVisible: false
  },
  getters: {
    getIsMeetingModalVisible: (state) => state.isMeetingModalVisible,
    getIsPhoneModalVisible: (state) => state.isPhoneModalVisible
  },
  mutations: {
    toggleMeetingModal (state) {
      state.isMeetingModalVisible = !state.isMeetingModalVisible
    },
    setIsMeetingModalVisible (state, bool) {
      state.isMeetingModalVisible = bool
    },
    togglePhoneModal (state) {
      state.isPhoneModalVisible = !state.isPhoneModalVisible
    },
    setIsPhoneModalVisible (state, bool) {
      state.isPhoneModalVisible = bool
    }
  },
  actions: {
  }
}
